import { Button, Checkbox, Col, Form, Input, Row, Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import useTranslate from '@core/hooks/useTranslate';
import '../../../../styles/pages/busk/components/_settlement-detail.scss';
import TextArea from 'antd/lib/input/TextArea';
import confirm from 'antd/lib/modal/confirm';
import buskforwardingdetail from '../services/buskforwardingdetail';

interface Props {
  formData: {
    id: number;
    name: string;
    manager: string;
    email: string;
    country: string;
    locale: string;
    description: string;
    active: boolean;
  };
  onUpdate: (data: {
    name?: string;
    manager?: string;
    email?: string;
    country?: string;
    locale?: string;
    description?: string;
    active?: boolean;
  }) => void;
}

const FormSellerInfo = ({ formData, onUpdate }: Props) => {
  const [form] = Form.useForm();
  const [isFormChanged, setIsFormChanged] = useState(false);

  useEffect(() => {
    form.setFieldsValue({
      id: formData?.id,
      name: formData?.name,
      manager: formData?.manager,
      email: formData?.email,
      country: formData?.country,
      locale: formData?.locale,
      description: formData?.description
    });
  }, [formData]);

  const [t] = useTranslate();

  const onFinish = (values: any) => {
    onUpdate(values);
    setIsFormChanged(false);
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo);
  };

  const onValuesChange = () => {
    setIsFormChanged(true);
  };

  const onStop = () => {
    confirm({
      wrapClassName: 'modal-request-fee-confirm',
      title: '중지하시겠습니까?',
      content: '확인을 클릭하면 해당 업체와의 대화가 차단됩니다.',
      icon: false,
      centered: true,
      okText: '확인',
      cancelText: '취소',
      onOk() {
        onUpdate({
          active: false
        });
      },
      onCancel() {}
    });
  };
  const onDelete = () => {
    confirm({
      wrapClassName: 'modal-request-fee-confirm',
      title: '삭제하시겠습니까?',
      content: '확인을 클릭하면 해당 업체의 계정이 삭제됩니다.',
      icon: false,
      centered: true,
      okText: '확인',
      cancelText: '취소',
      onOk() {},
      onCancel() {}
    });
  };
  const onStopCancel = () => {
    confirm({
      wrapClassName: 'modal-request-fee-confirm',
      title: '중지 해제하시겠습니까?',
      content: '확인을 클릭하면 해당 업체와 셀러와의 대화가 재개됩니다.',
      icon: false,
      centered: true,
      okText: '확인',
      cancelText: '취소',
      onOk() {
        onUpdate({
          active: true
        });
      },
      onCancel() {}
    });
  };

  return (
    <>
      <div
        style={{
          padding: '1rem',
          backgroundColor: 'white'
        }}
        id="busk-DetailForm"
      >
        <Form
          name="basic"
          className="forwarding-form"
          layout="vertical"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          form={form}
          onValuesChange={onValuesChange}
        >
          <Row gutter={24}>
            {/* Left Form */}
            <Col flex={'1'}>
              <Row>
                <Form.Item label="업체명" name="name">
                  <Input />
                </Form.Item>
              </Row>
              <Row>
                <Form.Item label="업체 관리자명" name="manager">
                  <Input />
                </Form.Item>
              </Row>
              <Row>
                <Form.Item label="아이디 (이메일)" name="email">
                  <Input />
                </Form.Item>
              </Row>
              <Row>
                <Form.Item label="국가명" name="country">
                  <Input />
                </Form.Item>
              </Row>
              <Row>
                <Form.Item label="소통 언어" name="locale">
                  <Input />
                </Form.Item>
              </Row>
              <Row>
                <Form.Item label="주요 업무" name="description">
                  <TextArea rows={5} style={{ borderRadius: 8 }} />
                </Form.Item>
              </Row>
            </Col>
          </Row>
        </Form>
        <div
          className=""
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginTop: 20
          }}
        >
          <div>
            {!formData?.active && (
              <Button
                style={{
                  padding: '.5rem 2.5rem',
                  height: 'auto',
                  border: 'none',
                  borderRadius: '7.25px',
                  backgroundColor: 'var(--btn-blue)',
                  color: 'white',
                  fontWeight: 500,
                  fontSize: 12
                }}
                onClick={onStopCancel}
              >
                중지 해제
              </Button>
            )}
          </div>
          <div style={{ display: 'flex', gap: 4 }}>
            {isFormChanged && (
              <Button
                style={{
                  padding: '.5rem 2.5rem',
                  height: 'auto',
                  border: 'none',
                  borderRadius: '7.25px',
                  backgroundColor: 'var(--btn-blue)',
                  color: 'white',
                  fontWeight: 500,
                  fontSize: 12
                }}
                onClick={() => form.submit()}
              >
                수정 요청
              </Button>
            )}
            <Button
              style={{
                padding: '.5rem 2.5rem',
                height: 'auto',
                border: 'none',
                borderRadius: '7.25px',
                backgroundColor: '#ABABAB',
                color: 'white',
                fontWeight: 500,
                fontSize: 12
              }}
              onClick={onDelete}
            >
              삭제
            </Button>
            {formData?.active && (
              <Button
                style={{
                  padding: '.5rem 2.5rem',
                  height: 'auto',
                  border: 'none',
                  borderRadius: '7.25px',
                  backgroundColor: 'var(--btn-blue)',
                  color: 'white',
                  fontWeight: 500,
                  fontSize: 12
                }}
                onClick={onStop}
              >
                중지
              </Button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default FormSellerInfo;
